import * as React from 'react';
import { useSelector } from 'react-redux';

import { StateType } from '../../reducers';
import { addModifiers } from '../../shared/helpers';

interface ChartButtonsProps {
  handlerHideAll: () => void;
  handlerShowAll: () => void;
  path: string[];
}

const ChartButtons = (props: ChartButtonsProps) => {
  // @ts-ignore
  const allActive = useSelector((state: StateType) => state.getIn(props.path.concat(['allActive'])));
  // @ts-ignore
  const hideActive = useSelector((state: StateType) => state.getIn(props.path.concat(['hideActive'])));

  return (
    <div className="chart__buttons">
      <button className={addModifiers('footer-menu__filters-buttons', hideActive ? ['active'] : [])} onClick={props.handlerHideAll}>
        None
      </button>
      <button className={addModifiers('footer-menu__filters-buttons', allActive ? ['active'] : [])} onClick={props.handlerShowAll}>
        All
      </button>
    </div>
  );
};

export default ChartButtons;
